import type { ReactNode } from 'react';

type Tone = 'error' | 'info' | 'success';

type Props = {
  tone?: Tone;
  title?: string;
  children?: ReactNode;
};

const tones: Record<Tone, string> = {
  error: 'border-red-200 bg-red-50 text-red-700',
  info: 'border-border bg-bg-soft text-ink-2',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-800',
};

export function Alert({ tone = 'info', title, children }: Props): JSX.Element {
  const role = tone === 'error' ? 'alert' : 'status';
  return (
    <div role={role} className={`rounded-md border px-3 py-2 text-sm ${tones[tone]}`}>
      {title ? <p className="font-medium">{title}</p> : null}
      {children ? <div className={title ? 'mt-1' : undefined}>{children}</div> : null}
    </div>
  );
}
